import { render, staticRenderFns } from "./LiveInfo.vue?vue&type=template&id=63943198&scoped=true"
import script from "./LiveInfo.vue?vue&type=script&lang=js"
export * from "./LiveInfo.vue?vue&type=script&lang=js"
import style0 from "./LiveInfo.vue?vue&type=style&index=0&id=63943198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63943198",
  null
  
)

export default component.exports